<style scoped>
footer span {
  display: inline;
  padding: 0 10px;
}
footer .copyright {
  color: #c9c9c9;
}
</style>
<template>
  <v-footer height="auto">
    <v-layout grey darken-4 row wrap>
      <v-flex grey darken-4 py-3 grey--text xs9 offset-xs1>
        <span class="copyright">&copy; Evident {{ year }}</span>
        <span>
          <a href="https://www.evidentscientific.com/en/imprint">Imprint</a>
        </span>
        <span><router-link to="/terms">Terms of Service</router-link></span>
        <span>
          <a href="https://www.evidentscientific.com/en/privacy">
            Privacy Notice
          </a>
        </span>
        <!--span>
          <a href="https://www.evidentscientific.com/en/cookies">Cookies</a>
        </span-->
        <span>
          <a
            href="javascript://"
            class="ot-sdk-show-settings"
            style="cursor:pointer;"
          >
            Cookies Settings
          </a>
        </span>
      </v-flex>
      <v-flex grey darken-4 py-3 grey--text xs1>
        <span>{{ appVersion }}</span>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
const today = new Date();

export default {
  name: "OlyFooter",
  computed: {
    year() {
      return today.getFullYear();
    }
  },
  data() {
    return {
      appVersion: "2.1.12"
    };
  }
};
</script>
